import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PersonaIcon } from '../components/ui/persona-icon';
import { GhostButton } from '../components/ui/ghost-button';
import { LogOut } from 'lucide-react';

const personas = [
  { 
    id: 'patient', 
    title: 'Patient',
    description: 'View your queue status and appointments',
    path: '/patient'
  },
  { 
    id: 'receptionist', 
    title: 'Receptionist',
    description: 'Manage patient queue and check-ins',
    path: '/receptionist'
  },
  { 
    id: 'doctor', 
    title: 'Doctor',
    description: 'Consultation and patient management',
    path: '/doctor'
  },
  { 
    id: 'billing', 
    title: 'Billing',
    description: 'Payment processing and invoicing',
    path: '/billing'
  },
  { 
    id: 'owner', 
    title: 'Owner',
    description: 'Business analytics and insights',
    path: '/owner'
  }
];

export const PersonaSelector = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handlePersonaSelect = (path) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-4xl animate-slide-up">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 
            className="text-heading-1 mb-3"
            style={{ color: 'var(--color-text-primary)' }}
          >
            Welcome, {user?.name}
          </h1>
          <p 
            className="text-body-sm mb-6"
            style={{ color: 'var(--color-text-tertiary)' }}
          >
            Choose your workspace to continue
          </p>
          <GhostButton onClick={logout} data-testid="logout-button">
            <LogOut size={16} strokeWidth={1.75} />
            Sign Out
          </GhostButton>
        </div>

        {/* Persona Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {personas.map((persona) => (
            <button
              key={persona.id}
              onClick={() => handlePersonaSelect(persona.path)}
              className="glass-primary rounded-[var(--radius-xl)] p-8 hover-lift interactive text-left"
              data-testid={`persona-card-${persona.id}`}
            >
              <div className="flex flex-col items-center text-center gap-4">
                <PersonaIcon persona={persona.id} size="lg" />
                <div>
                  <h3 
                    className="text-heading-3 mb-2"
                    style={{ color: 'var(--color-text-primary)' }}
                  >
                    {persona.title}
                  </h3>
                  <p 
                    className="text-body-sm"
                    style={{ color: 'var(--color-text-tertiary)' }}
                  >
                    {persona.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PersonaSelector;